import { gql } from 'apollo-angular';
import { MinimumWageScopeConfig } from '../manage-minimum-wage-form/enum/minimum-wage-scope.enum';

export const minimumWagesMutations = {
  [MinimumWageScopeConfig.ALL_PROJECTS_IN_JURISDICTION]: gql`
    mutation createMinimumWages(
      $tenantId: UUID!
      $input: MinimumWageAllProjectsInJurisdictionInputModelInput!
    ) {
      createMinimumWageForAllProjectsInJurisdiction(
        tenantId: $tenantId
        input: $input
      ) {
        data {
          createdBy
          createdDate
          effectiveDate
          id
          jurisdictionId
          modifiedBy
          modifiedDate
          rate
          scopeId
          tenantId
        }
        errors {
          message
        }
      }
    }
  `,

  [MinimumWageScopeConfig.ALL_LOCATIONS_IN_PROJECT]: gql`
    mutation createMinimumWages(
      $tenantId: UUID!
      $input: MinimumWageAllLocationsInProjectInputModelInput!
    ) {
      createMinimumWageForAllLocationsInProject(
        tenantId: $tenantId
        input: $input
      ) {
        data {
          createdBy
          createdDate
          effectiveDate
          id
          jurisdictionId
          modifiedBy
          modifiedDate
          rate
          scopeId
          tenantId
        }
        errors {
          message
        }
      }
    }
  `,
  [MinimumWageScopeConfig.SPECIFIC_LOCATION_IN_PROJECT]: gql`
    mutation createMinimumWages(
      $tenantId: UUID!
      $input: MinimumWageSpecificLocationInProjectInputModelInput!
    ) {
      createMinimumWageForSpecificLocationInProject(
        tenantId: $tenantId
        input: $input
      ) {
        data {
          createdBy
          createdDate
          effectiveDate
          id
          jurisdictionId
          modifiedBy
          modifiedDate
          rate
          scopeId
          tenantId
        }
        errors {
          message
          extensions {
            attemptedValue
            errorCode
            propertyName
            severity
          }
        }
      }
    }
  `,
};
